import { LoadingSpinner } from '@spins-gcp/shared-components-react';
import { NoAccessMessage } from '../components/no-access-message/no-access-message';
import { useRedirectToFirstApp } from '../hooks/useRedirectToFirstApp';

export const LandingPage = () => {
  const { apps, loading } = useRedirectToFirstApp();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!apps.length) {
    return <NoAccessMessage message="No apps available for your account." />;
  }

  return null;
};
